import {
  all,
  take
} from 'redux-saga/effects';
import { REHYDRATE } from 'redux-persist/lib/constants';

import errorHandler from '../utils/errorHandler';

export function configureRootSaga(sagas = [], numberOfPersistedReducers = 1) {
  return function* rootSaga() {
    try {
      for (let i = 0; i < numberOfPersistedReducers; i += 1) {
        yield take(REHYDRATE);
      }
      yield all(sagas);
    } catch (error) {
      errorHandler(error);
    }
  };
}

export default configureRootSaga;
